import React from 'react';
import { motion } from 'framer-motion';
export function ImpactQuote() {
  return <section className="bg-cream text-navy py-32 px-5 relative overflow-hidden" data-id="element-81">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-20 bg-gold/40" data-id="element-82"></div>
      <div className="max-w-4xl mx-auto text-center" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-84">
          <h2 className="font-playfair text-3xl md:text-5xl lg:text-6xl font-bold leading-tight" data-id="element-85">
            "El problema no está en la cotización. Está en{' '}
            <span className="text-gold italic" data-id="element-86">cómo se comunica</span>."
          </h2>
        </motion.div>
      </div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-20 bg-gold/40" data-id="element-87"></div>
    </section>;
}